/* Affichage générique des ExamAuthoringWarning (packages/domain/src/exam/exam-authoring-job.ts) —
   avant ce composant, ce type n'était affiché nulle part côté web (constat de
   l'investigation feasibility.md), qu'il s'agisse d'un conflit de barème
   (answer_key_conflict, déjà produit par le job de complétion de corrigé) ou
   d'un visuel non extrait (image_extraction_missing/variant_missing, ce lot).
   Un seul composant pour toutes les origines : le prof n'a pas à savoir de
   quel job vient l'avertissement, seulement qu'il doit vérifier quelque chose. */
import { WarningCircle } from '@phosphor-icons/react';

export interface AuthoringWarningRow {
  readonly type: string;
  readonly sectionId?: string;
  readonly note: string;
}

interface Props {
  warnings: readonly AuthoringWarningRow[];
  className?: string;
}

export default function AuthoringWarningsList({ warnings, className }: Props) {
  if (warnings.length === 0) return null;
  return (
    <div
      role="alert"
      className={`flex flex-col gap-2 rounded-[var(--naia-r-card)] border border-[var(--naia-tertiary)] bg-[var(--naia-warn-bg)] p-3 ${className ?? ''}`}
    >
      <p className="m-0 flex items-center gap-2 text-[13px] font-bold text-[var(--naia-text-primary)]">
        <WarningCircle size={17} weight="fill" className="shrink-0 text-[var(--naia-tertiary)]" />
        {warnings.length > 1 ? `${warnings.length} points à vérifier` : '1 point à vérifier'}
      </p>
      <ul className="m-0 list-disc space-y-1 pl-5">
        {warnings.map((w, i) => (
          <li key={`${w.sectionId ?? 'x'}-${i}`} className="text-[12.5px] leading-[1.45] text-[var(--naia-text-primary)]">
            {w.note}
          </li>
        ))}
      </ul>
    </div>
  );
}
